<footer class="w-full bg-primary pb-md text-secondary" *transloco="let t">
  <div class="h-layout pt-2xl">
    <div class="flex flex-col md:flex-row-reverse md:justify-between">
      <div class="shrink-0 md:flex md:w-1/4 md:flex-col md:items-end md:justify-between">
        <ng-container *ngTemplateOutlet="langs"></ng-container>
        <div class="mt-2xl">
          <ng-container *ngTemplateOutlet="socials"></ng-container>
        </div>
      </div>
      <div class="order-last mt-2xl md:order-none md:mx-xl md:mt-0 md:w-2/4">
        <bgo-footer-seo-keywords></bgo-footer-seo-keywords>
      </div>
      <div class="mt-2xl shrink-0 md:mt-0 md:w-1/4">
        <ng-container *ngTemplateOutlet="address"></ng-container>
        <div class="mt-xl">
          <ng-container *ngTemplateOutlet="links"></ng-container>
        </div>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="copyright"></ng-container>
  </div>
</footer>

<ng-template #langs>
  <bgo-language-picker-list></bgo-language-picker-list>
</ng-template>

<ng-template #socials>
  <nav aria-label="Social media" *transloco="let t">
    <ul class="inline-list">
      <li>
        <a href="https://www.linkedin.com/company/buildigo.com" bgoOpenNewTab>
          <fa-icon [icon]="faLinkedIn" size="2x"></fa-icon>
        </a>
      </li>
      <li>
        <a href="https://www.facebook.com/buildigo" bgoOpenNewTab>
          <fa-icon [icon]="faFaceBook" size="2x"></fa-icon>
        </a>
      </li>
      <li>
        <a href="https://twitter.com/buildigo" bgoOpenNewTab>
          <fa-icon [icon]="faTwitter" size="2x"></fa-icon>
        </a>
      </li>
      <li>
        <a href="https://instagram.com/buildigo.ch" bgoOpenNewTab>
          <fa-icon [icon]="faInstagram" size="2x"></fa-icon>
        </a>
      </li>
    </ul>
  </nav>
</ng-template>

<ng-template #address>
  <address class="text-base not-italic" *transloco="let t">
    <div class="mb-sm heading-lg font-semibold md:heading-base">{{ t('footer.contact.title') }}</div>
    <ul class="address-list">
      <li>{{ t('shared.support.operatingHours') }}</li>
      <li>
        <a [href]="t('shared.support.email') | bgoMailTo">{{ t('shared.support.email') }}</a>
      </li>
      <li>
        <a [href]="t('shared.support.phone') | bgoTel">{{ t('shared.support.phone') }}</a>
      </li>
    </ul>
  </address>
</ng-template>

<ng-template #copyright>
  <div class="mt-xl text-left md:mt-3xl md:flex md:justify-between" *transloco="let t">
    <div class="text-sm">
      <fa-icon [icon]="faHeart"></fa-icon>
      {{ t('footer.madeWithLove') }}
    </div>
    <div class="mt-sm text-xs text-grey-400 md:mt-0">{{ t('footer.copyright') }}</div>
  </div>
</ng-template>

<!-- last due to size -->
<ng-template #links>
  <ng-container *transloco="let t">
    <nav aria-label="Secondary">
      <ul class="nav-list">
        <li>
          <a [routerLink]="linkService.homePath" id="footerHome">
            <fa-icon [icon]="faHouse"></fa-icon>
            {{ t('footer.siteMap.home') }}
          </a>
        </li>
        <li>
          <a [routerLink]="linkService.localizedPathTo(APPLICATION_ROUTES.ARTICLE_OVERVIEW)" id="footerArticles">
            <cft-dynamic-icon [icon]="{name: 'services', collection: 'fak'}"></cft-dynamic-icon>
            {{ t('footer.siteMap.articles') }}
          </a>
        </li>
        <li>
          <a [routerLink]="linkService.localizedPathTo(APPLICATION_ROUTES.ABOUT_US)" id="aboutUsButton">
            <cft-dynamic-icon [icon]="{name: 'buildigo', collection: 'fak'}"></cft-dynamic-icon>
            {{ t('footer.siteMap.aboutUs') }}
          </a>
        </li>
        @if (showProSignUp) {
          <li>
            <a [routerLink]="linkService.localizedPathTo(APPLICATION_ROUTES.PRO_REGISTER)" id="footerProRegisterButton">
              <fa-icon [icon]="faLock"></fa-icon>
              {{ t('footer.siteMap.craftmanRegistration') }}
            </a>
          </li>
        }
      </ul>
    </nav>
    <nav aria-label="Legal" class="mt-xl">
      @if (showLegalLinks) {
        <ul class="legal-list">
          <li>
            <a [href]="linkService.localizedPathTo(APPLICATION_ROUTES.PRO_TERMS_AND_CONDITIONS)" bgoOpenNewTab>
              {{ t('footer.legalMenu.tcPro') }}
            </a>
          </li>
          <li>
            <a [href]="linkService.localizedPathTo(APPLICATION_ROUTES.CLIENT_TERMS_AND_CONDITIONS)" bgoOpenNewTab>
              {{ t('footer.legalMenu.tcClient') }}
            </a>
          </li>
          <li>
            <a [href]="linkService.localizedPathTo(APPLICATION_ROUTES.DATA_PRIVACY)" bgoOpenNewTab>
              {{ t('footer.legalMenu.dataProtection') }}
            </a>
          </li>
          <li>
            <a id="impressumButton" [href]="linkService.localizedPathTo(APPLICATION_ROUTES.IMPRESSUM)" bgoOpenNewTab>
              {{ t('footer.legalMenu.impressum') }}
            </a>
          </li>
          <li>
            <a [routerLink]="linkService.localizedPathTo(APPLICATION_ROUTES.MEDIA)" id="mediaButton">
              {{ t('footer.siteMap.media') }}
            </a>
          </li>
        </ul>
      }
    </nav>
  </ng-container>
</ng-template>
